
import { useCampaignCreation as useCampaignCreationHook } from './sms/campaign/useCampaignCreation';
export type { CampaignData } from './sms/campaign/types';

// Re-export the hook for backwards compatibility
export const useCampaignCreation = useCampaignCreationHook;
